import { defineMessages } from 'react-intl';

const messages = defineMessages({
  disabledDateErrorMessage: {
    id: 'App.LeaseDataTabForm.LeaseRentAmountModal.RentStep.disabledDateErrorMessage',
    defaultMessage:
      "Start Date cannot be earlier than the previous rent step's start date.",
  },
});

export default messages;
